module.exports = __webpack_public_path__ + "img/kma_gallery11.ebabb2b6.jpg";